<template>
  <AppDialog
    v-if="hasActiveIntegration"
    v-model="dialogModel"
    width="882"
    persistent
    @close="close"
  >
    <VCard>
      <div class="int-dialog d-flex">
        <div v-if="image" class="int-dialog__image-wrap">
          <slot name="image" />
        </div>
        <div class="int-dialog__text-wrap">
          <VCardTitle class="int-dialog__title">
            <slot name="title" />
          </VCardTitle>
          <VCardText class="int-dialog__text">
            <slot name="text" />
          </VCardText>
          <VCardText class="int-dialog__add-text add-text">
            <slot name="add-text" />
          </VCardText>
          <VCardText>
            <VBtn @click="close" color="success">
              {{ $t('button') }}
            </VBtn>
          </VCardText>
        </div>
      </div>
    </VCard>
  </AppDialog>
</template>

<script>
import useDialog from '@/compositions/useDialog';
import { toRefs, watch } from '@vue/composition-api';
import useUser from '@/compositions/useUser';
import useIntegrations from '@/compositions/useIntegrations';
import AppDialog from '@/components/AppDialog';

export default {
  name: 'IntegrationsHelpDialog',
  components: { AppDialog },
  props: {
    value: Boolean,
    item: {
      type: String,
      required: true,
    },
    image: Boolean,
  },
  setup(props, { emit }) {
    const { value, item } = toRefs(props);
    const { dialogModel, dialogController } = useDialog({ emit, value });
    const { userSettings, putSettings } = useUser();
    const { hasActiveIntegration, fetchAll } = useIntegrations();
    fetchAll();

    function store() {
      putSettings(item.value, false);
    }

    dialogModel.value = userSettings.value[item.value];

    watch(userSettings, (settings) => {
      dialogModel.value = settings[item.value];
    });

    function close() {
      store();
      emit('close');
      dialogController.closeDialog();
    }

    return {
      dialogModel,
      dialogController,
      close,
      hasActiveIntegration,
    };
  },
};
</script>

<style lang="scss" scoped>
  .int-dialog {
    align-items: stretch;
    &__image-wrap {
      max-width: 25rem;
      height: 100%;
    }
    &__text-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 1rem 1.5rem 1rem 2.75rem;
      color: #091A35;
    }
    &__title {
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 1.2;
      margin-bottom: 0.25rem;
    }
    &__text {
      font-size: 1.0625rem;
      line-height: 1.53;
      margin-bottom: 0.75rem;
      padding-bottom: 0;
    }
    &__add-text {
      font-size: 0.875rem;
      line-height: 1.29;
      opacity: 0.6;
      padding-top: 0;
    }
  }

  @media screen and (max-width: 930px) {
    .int-dialog {
      &__image-wrap {
        max-width: 50%;
      }
      &__text-wrap {
        padding: 0.75rem 1rem 1rem 1.25rem;
      }
      &__title {
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 1.2;
        margin-bottom: 0.25rem;
      }
      &__text {
        font-size: 1rem;
      }
    }
  }
  @media screen and (max-width: 760px) {
    .int-dialog {
      &__image-wrap {
        display: none;
      }
      &__text-wrap {
        padding: 0.75rem 1.25rem 1rem 1.25rem;
      }
      &__title {
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 1.2;
        margin-bottom: 0.25rem;
      }
      &__text {
        font-size: 1rem;
      }
    }
  }
  @media screen and (max-width: 560px) {
    .int-dialog {
      &__text-wrap {
        padding: 1rem 1.125rem 1rem 0.75rem;
      }
    }
  }

</style>

<i18n lang="yml" locale="ru">
  button: Понятно
</i18n>
